import PubSub from 'pubsub-js';
// import WebFont from 'webfontloader';
import { Responsive } from '../utils';

const COMPONENT_NAME = 'tcl-page';
const EVENT_KEY = COMPONENT_NAME;

export const PageEvents = {
  PAGE_READY: `${EVENT_KEY}.pageReady`,
};

/**
 * version    1.0
 * class      <type> (Page)
 * classdesc  Component representing the whole Page (down from html)
 */
export class Page {
  constructor() {
    this._isPageReady = false;
    this._findUIElements();
    this._bindEvents();
    this._initUI();
  }

  // private methods

  _findUIElements() {
    this._els = {
      html: $('html'),
      body: $('body'),
    };
  }

  _bindEvents() {
    // component events
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      this._isPageReady = true;
      this._els.body.addClass('tcl-page--is-ready');
    });
  }

  _initUI() {
    this._initTextColors();
    this._initButtons();
    this._initBackgroundColors();
    this._initMenuCurrentPage();

    // // on webfont loaded
    // WebFont.load({
    //   active: () => {
    //     PubSub.publish(PageEvents.PAGE_READY);
    //   },
    //   google: {
    //     families: [
    //       // Nunito Sans: https://fonts.google.com/share?selection.family=Nunito%20Sans:ital,wght@0,300;0,400;0,700;0,800;1,400
    //       'Nunito+Sans:ital,wght@0,300;0,400;0,700;0,800;1,400',
    //       'DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000',
    //       'DM+Serif+Text:ital@0;1&display=swap',
    //     ],
    //   },
    // });

    // // contatore caratteri input
    // if ($('.form-group .word-counter').length > 0) {
    //   $('.form-group .word-counter').on('keyup', function () {
    //     const { length } = $(this).val();
    //     $(this).parent().find('.chars').text(`${length}/${(this).maxLength}`);
    //   });
    // }

    // // custom select
    // if ($('.custom-select').length > 0) {
    //   $('.custom-select').select2({
    //     dropdownParent: $('#select-container'),
    //     placeholder: 'Categoria*',
    //     width: '100%',
    //   });
    // }
  }

  // set class on menu voice related to current page
  _initMenuCurrentPage($container = $('body')) {
    const currentUrl = window.location.href;
    const splittedUrl = currentUrl.split('/');
    const lastPartUrl = splittedUrl[splittedUrl.length - 1].split('.')[0];

    $container.find('.nav-item a').each(function () {
      if ($(this).data('page-name') === lastPartUrl) {
        $(this).closest('.nav-item').addClass('current-page');
      } else {
        $(this).closest('.nav-item').removeClass('current-page');
      }
    });
  }

  // set text color as specified via data attribute
  _initTextColors($container = $('body')) {
    $container.find('[data-text-color]').each(function () {
      $(this).css('color', $(this).data('text-color'));
    });
    if (Responsive.getCurrentBreakpointName() === 'xs') {
      $container.find('[data-text-color-mobile]').each(function () {
        $(this).css('color', $(this).data('text-color-mobile'));
      });
    }
  }

  // set background (bg) color as specified via data attribute
  _initBackgroundColors($container = $('body')) {
    $container.find('[data-background-color]').each(function () {
      $(this).css('background-color', $(this).data('background-color'));
    });
    if (Responsive.getCurrentBreakpointName() === 'xs') {
      $container.find('[data-background-color-mobile]').each(function () {
        $(this).css('background-color', $(this).data('background-color-mobile'));
      });
    }
  }

  _initButtons($container = $('body')) {
    $container.find('[data-btn-icon]').each(function () {
      const $btn = $(this);
      if ($btn.find('.svg-icon').length === 0) {
        const iconName = $btn.attr('data-btn-icon');
        const flip = $btn[0].hasAttribute('data-btn-icon-flip');
        const icon = `<svg role="img" class="svg-icon svg-icon--${iconName}" aria-hidden="true"><use xlink:href="#sprite-${iconName}"></use></svg>`;
        if (flip) {
          $btn.prepend(icon);
        } else {
          $btn.append(icon);
        }
      }
    });
  }

  // public methods

  isPageReady() {
    return this._isPageReady;
  }
}
